import { Box, Fade, Hidden } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { connect } from 'react-redux'
import { MainLayout } from 'components/core'
import NivosDrawer from 'components/drawer'
import {
  NivosBody,
  NivosFooter,
  NivosHeader,
  NivosMobileNavBar
} from 'components/nivos'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps & PropsWithChildren

const NivosMainLayoutFC: React.FC<any> = (props: AppProps) => {
  const { layout, theme, children } = props
  return (
    <Fade in={true} timeout={2000}>
      <Box bgcolor={theme.primaryColor}>
        <Hidden lgDown>
          <MainLayout
            open={layout.drawerIsOpen}
            minHeight={'100vh'}
            display={'flex'}
            flexDirection={'column'}
          >
            <NivosDrawer />
            <NivosHeader />
            <NivosBody>{children}</NivosBody>
            <NivosFooter />
          </MainLayout>
        </Hidden>
        <Hidden lgUp>
          <Box>
            <NivosMobileNavBar />
            <NivosBody>{children}</NivosBody>
          </Box>
        </Hidden>
      </Box>
    </Fade>
  )
}
const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const NivosMainLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosMainLayoutFC) as React.FC<PropsWithChildren>

export default NivosMainLayout
